// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rkoftgi{border-radius:8px}._16jlkb7n{flex-grow:1}\n._19bvv77o{padding-left:var(--ds-space-025,2px)}\n._1bsb1ns9{width:-moz-fit-content;width:fit-content}\n._1e0c1txw{display:flex}\n._1pbykb7n{z-index:1}\n._ca0qv77o{padding-top:var(--ds-space-025,2px)}\n._kqswh2mm{position:relative}\n._n3tdv77o{padding-bottom:var(--ds-space-025,2px)}\n._u5f3v77o{padding-right:var(--ds-space-025,2px)}", ""]);
// Exports
module.exports = exports;
